export const FONT_FAMILY = "'Asap', serif";
export const FONT_URL =
  "https://fonts.googleapis.com/css?family=Asap:400,400i,700&display=swap";
export const BORDER_RADIUS = "6px";
